import React, { createContext, useContext, useEffect, useState } from 'react';

const NetworkContext = createContext(null);

export const useNetwork = () => {
    const context = useContext(NetworkContext);
    if (!context) {
        throw new Error('useNetwork must be used within a NetworkProvider');
    }
    return context;
};

const getWebStaticMetadata = () => ({
    app_version: process.env.REACT_APP_VERSION || 'unknown',
    platform: 'web',
    os: navigator.userAgentData?.platform || navigator.platform || 'unknown',
});

export const NetworkProvider = ({
    children,
    isLoggedIn = false,
    pingAPI = () => null,
    requestBandwidth = () => null,
    saveNetworkMetrics = () => null,
}) => {
    const [metrics, setMetrics] = useState({
        is_connected: null,
        is_internet_reachable: null,
        network_type: null,
        download_speed_mbps: null,
        latency_ms: null,
    });

    const checkNetwork = async () => {
        const [speed, latency] = await Promise.all([requestBandwidth(), pingAPI()]);

        const newMetrics = {
            is_connected: navigator.onLine,
            is_internet_reachable: navigator.onLine,
            network_type: navigator.connection?.effectiveType || null,
            download_speed_mbps: speed,
            latency_ms: latency,
        };

        setMetrics(newMetrics);
        saveNetworkMetrics(newMetrics, getWebStaticMetadata());
    };

    useEffect(() => {
        if (!isLoggedIn) return;

        checkNetwork();

        const intervalId = setInterval(() => {
            checkNetwork();
        }, 60 * 1000);

        return () => clearInterval(intervalId);
    }, [isLoggedIn]);

    return (
        <NetworkContext.Provider value={metrics}>
            {children}
        </NetworkContext.Provider>
    );
};
